import { useEffect, useRef, useState } from "react";
import LayeredDashboardHeader from "../../LayeredDashboardHeader";
import useCustomNavigate from "../../../components/operational/goBack";
import PrimaryButton from "../../../components/ui/PrimaryButton";
import CreateAction from "../../../components/operational/createAction";
import { useNavigate } from "react-router-dom";
import { localeStringConverter } from "../../../helper/Converters";
import { useDispatch } from "react-redux";
import myUserSlice from "../../../redux/myUserSlice";
import { license } from "../../../data/license";

const plans = [{
    name: "Mevcut Plan",
    key: "defaultLicense.title"
},
{
    name: "Periyot",
    key: "defaultLicense.expires"
},
{
    name: "Başlangıç Tarihi",
    key: "startDate",
    converter: (data) => { return localeStringConverter(data, true) }
},
{
    name: "Bitiş Tarihi",
    key: "endDate",
    converter: (data) => { return localeStringConverter(data, true) }
}
]

const LicenseDetails = ({ tab }) => {

    const goBack = useCustomNavigate(tab)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [licenseData, setLicenseData] = useState({
        type: "",
        startDate: "",
        expiredAt: ""
    })

    const getLicense = async () => {
        const response = await CreateAction({
            method: 'get',
            path: `/myLicense`,
            showPreLoader: true,
            isFileUploading: false,
        });
        if (response.error) return

        setLicenseData(response.result?.resultData)

        const storeLicense = license[response.result?.resultData?.licenseType] || license['FREE'];
        dispatch(myUserSlice.actions.setLicense(storeLicense));


    }
    useEffect(() => {
        getLicense()
    }, [])

    return (
        <>
            <LayeredDashboardHeader tab={tab}></LayeredDashboardHeader>
            <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
                <div>
                    <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto gap-[20px]">
                        <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%] flex flex-col gap-[30px]">
                            <div className="flex flex-row justify-between w-full items-center relative pb-[20px]">
                                <div className="text-[#5E5873] text-[18px] font-semibold">Lisans Detayları</div>
                                <PrimaryButton onClick={() => { navigate("/dashboard/theme-settings/license-details/purchase") }} value={"Planı Yükselt"}></PrimaryButton>
                                <div className="border-b-1 border-gray-200 absolute bottom-[0px] left-[-20px] w-[calc(100%+40px)]"></div>
                            </div>
                            <div className="flex flex-row gap-[20px] relative">
                                {plans.map((plan, index) => {
                                    const keyArray = plan.key.split(".")

                                    const tabData = keyArray.reduce((acc, key, i) => {
                                        return acc?.[key]
                                    }, licenseData)
                                    return (
                                        <div className="relative flex flex-row items-center gap-[20px]">
                                            <div className="flex flex-col gap-[10px]" >
                                                <span className="text-gray-800 text-[15px] text-bold" >{plan.name}</span>
                                                <span className="text-gray-500 text-[14px] text-bold" >{plan.converter ? plan.converter(tabData) : tabData || ""}</span>
                                            </div>
                                            {index !== plans.length - 1 &&
                                                <div className="w-[1px] h-full bg-gray-300 min-h-[0px] relative"></div>
                                            }
                                        </div>

                                    )

                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>


    );
};

export default LicenseDetails;
